import React from 'react'

const Star = ({ on }) => {
  return (
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0524 1.13317L8.93062 8.28827L1.4717 8.83046C-0.179943 8.95052 -0.371322 10.7488 0.548258 11.565L6.38074 16.7422L4.59945 24.0105C4.26064 25.3928 5.97393 26.2824 6.911 25.7326L13.6431 21.7827C13.6431 21.7827 17.885 24.412 20.0059 25.7266C21.2151 26.4762 22.5871 25.1197 22.3534 24.0586C21.7933 21.5166 20.6733 16.4328 20.6733 16.4328L26.3867 11.6071C27.6534 10.5372 26.7545 8.96819 25.5288 8.84873L17.766 8.09212L14.9361 1.16935C14.1991 -0.63346 12.5972 -0.115291 12.0524 1.13326V1.13317Z"
        fill={on ? '#BE9137' : '#C4C4C4'}
      />
    </svg>
  )
}

export default Star
